import React, { FC, useMemo, useState } from 'react';

import { useFormikContext } from 'formik';

// Constants
import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';
import ICONS from '../../../../../../constants/icons';

// Hooks
import useCMSPlaceholderQuery from '../../../../../../hooks/cms-placeholders/useCMSPlaceholderQuery';

// Models
import { CMSPlaceholderElement } from '../../../../../../models/editor.model';
import { FormulaTestMessageFormValues } from 'models/formula.model';

interface TestFormulaCMSBlockProps {
    cmsElement: CMSPlaceholderElement;
}

const TestFormulaCMSBlock: FC<TestFormulaCMSBlockProps> = ({ cmsElement }) => {
    const { setFieldValue, values } =
        useFormikContext<FormulaTestMessageFormValues>();

    const [inputValue, setInputValue] = useState<string | undefined>(
        values?.filters?.cms_placeholders?.[cmsElement.cmsPlaceholderId!],
    );

    const cmsPlaceholder = useCMSPlaceholderQuery();

    const cms = useMemo(
        () =>
            cmsPlaceholder?.data?.messageable.find(
                (p) => p.id === cmsElement.cmsPlaceholderId,
            ),
        [cmsPlaceholder, cmsElement],
    );

    const sampleValue = cms?.sample_value;

    return (
        <>
            <StyledCMSIcon />
            {sampleValue ? (
                sampleValue
            ) : (
                <CMSPlaceholderInput
                    key={cmsElement.id}
                    type="text"
                    placeholder={`{${cms?.name}}`}
                    value={inputValue}
                    onChange={(e) => {
                        setInputValue(e.target.value);
                    }}
                    onBlur={(e) => {
                        setFieldValue(
                            `filters.cms_placeholders.${cmsElement.cmsPlaceholderId}`,
                            e.target.value,
                        );
                    }}
                />
            )}
        </>
    );
};

export default TestFormulaCMSBlock;

const CMSPlaceholderInput = styled.input({
    display: 'block',
    width: '100%',
    fontSize: aampeTheme.size.font.default,
    lineHeight: aampeTheme.size.lineHeight.default,
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    color: aampeTheme.colors.textAccessibleWG01,
    borderRadius: aampeTheme.borderRadius.default,
    padding: aampeTheme.spacing4(3, 4),
    '::placeholder': {
        color: aampeTheme.colors.textAccessibleWG01,
    },
});

const StyledCMSIcon = styled(ICONS.cmsPlaceHolder)({
    width: '20px',
    height: '20px',
    color: aampeTheme.colors.textAccessibleWG01,
});
